<template>
  <v-dialog
    v-model="show"
    width="40vw"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    scrollable
    persistent
  >
    <v-card height="auto" elevation="5" class="rounded-xl" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        Nueva solicitud cepa
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" xl="3" lg="4">
              <v-btn
                rounded
                color="primary"
                small
                block
                @click="showHistoryRequest = true"
              >
                <v-icon> mdi-history </v-icon>
                Historial
              </v-btn>
            </v-col>
          </v-row>
          <v-form ref="strainForm" lazy-validation>
            <v-row>
              <v-col cols="12" class="pb-1">
                <v-autocomplete
                  v-model="form.identification"
                  :search-input.sync="search"
                  :items="identificationsFounded"
                  :loading="loader"
                  return-object
                  outlined
                  dense
                  clearable
                  :item-text="formatItemText"
                  no-data-text="No se ha encontrado ningún microorganismo"
                  label="Busca microorganismo"
                  :rules="validation()"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                class="pt-1"
                v-if="
                  form.identification && form.identification.moType == 'fungi'
                "
              >
                <v-text-field
                  v-model="form.qtyFlask"
                  outlined
                  dense
                  clearable
                  label="Indica el número de cajas"
                  :rules="validation()"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                class="py-1"
                v-if="
                  form.identification &&
                  form.identification.moType == 'bacteria'
                "
              >
                <v-text-field
                  v-model="form.qtyFlask"
                  outlined
                  dense
                  clearable
                  label="Indica el número de tubos"
                  :rules="validation()"
                ></v-text-field>
              </v-col>
              <v-col cols="12" class="pt-1">
                <v-text-field
                  v-model="form.dateDelivery"
                  outlined
                  dense
                  clearable
                  type="date"
                  label="Fecha de entrega (opcional)"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="red"
                block
                rounded
                @click="closeModal"
                dark
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                color="primary"
                block
                rounded
                @click="requestStrain"
                :loading="isLoading"
                >Aceptar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
    <HistoryRequest v-if="showHistoryRequest" v-model="showHistoryRequest" />
  </v-dialog>
</template>

<script>
//vuex
import { mapActions, mapState, mapMutations } from "vuex";
//axios
import axios from "axios";
//validations
import { requiredValidation } from "@/helpers/validations.js";
//components
import HistoryRequest from "@/components/cepario-production/modals/HistoryRequest.vue";
export default {
  components: {
    HistoryRequest,
  },
  data: () => ({
    showHistoryRequest: false,
    loader: false,
    identification: null,
    search: null,
    identificationsFounded: [],
    isLoading: false,
    form: {
      identification: null,
      qtyFlask: null,
      dateDelivery: null,
    },
  }),
  props: {
    value: Boolean,
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  methods: {
    ...mapActions("bioactives", ["searchBioactives", "addStrainRequest"]),
    ...mapMutations(["SET_CANCEL_TOKEN"]),
    formatItemText(item) {
      return `${item.identificationName} - ${item.sequenceId}`;
    },
    async requestStrain() {
      if (this.$refs.strainForm.validate()) {
        //make strain request to cepario production
        try {
          this.isLoading = true;
          let response = await this.addStrainRequest(this.form);
          if (response) {
            if (!response.error) {
              this.identification = null;
              this.search = null;
              this.identificationsFounded = [];
              this.$swal({
                icon: "success",
                title: `Cepa solicitada`,
                showConfirmButton: false,
                timer: 2000,
              });
              this.show = false;
              // this.$router.push(`/cepario-production`);
            } else {
              this.showErrotMessage();
            }
          } else {
            this.showErrotMessage();
          }
        } catch (e) {
          console.log(e);
          this.showErrotMessage();
        }
        this.isLoading = false;
      }
    },
    validation(name) {
      return requiredValidation(name);
    },
    showErrotMessage() {
      this.$swal({
        icon: "error",
        title: `Algo salio mal al solicitar cepa`,
        showConfirmButton: false,
        timer: 2000,
      });
    },
    closeModal() {
      this.show = false;
      this.identification = null;
      this.search = null;
      this.identificationsFounded = [];
    },
  },
  watch: {
    async search(val) {
      if (!val) return;
      else {
        this.loader = true;

        if (typeof this.cancelToken != typeof undefined) {
          this.cancelToken.cancel("Operation canceled due to new request.");
        }

        //Save the cancel token for the current request
        this.SET_CANCEL_TOKEN(axios.CancelToken.source());

        try {
          const response = await this.searchBioactives({
            name: val,
          });
          if (response.error) throw response;

          this.identificationsFounded = response.strains;
        } catch (e) {
          console.log(e);
        }
        this.loader = false;
      }
    },
  },
  destroyed() {
    this.identification = null;
    this.search = null;
    this.identificationsFounded = [];
  },
};
</script>
